import { BREAKPOINT_COLS, WIDGET_CLASS_CONSTRAINTS } from '../../constants';
import { buildStackedLayout, expandWidgetsToAvailableSpace } from '../../utils';

/**
 * Transforms a widget from the layout contract into a react-grid-layout item.
 * Merges layout position (x,y,w,h) with constraints (minW,maxW,minH,maxH).
 */
const buildLayoutItem = (widget) => {
  const { layout, constraints, instance_uuid } = widget;
  const fallbackConstraints = WIDGET_CLASS_CONSTRAINTS.CLASS_2_STANDARD || {};
  const resolvedConstraints = constraints || fallbackConstraints;

  return {
    i: instance_uuid,
    x: layout.x,
    y: layout.y,
    w: layout.w,
    h: layout.h,
    ...resolvedConstraints,
  };
};

/**
 * Merges stored layout positions with current widget constraints from the contract.
 */
const mergeStoredWithConstraints = (storedItems, widgetsByUuid) => {
  if (!storedItems?.length) return storedItems;

  return storedItems.map((item) => {
    const widget = widgetsByUuid[item.i];
    if (!widget) return item;

    const resolvedConstraints = widget.constraints || WIDGET_CLASS_CONSTRAINTS.CLASS_2_STANDARD || {};
    return {
      ...item,
      ...resolvedConstraints,
      i: item.i,
      x: item.x,
      y: item.y,
      w: item.w,
      h: item.h,
    };
  });
};

const buildResponsiveLayouts = (lgLayout) => {
  if (!lgLayout?.length) return {};

  return {
    lg: lgLayout,
    md: lgLayout,
    sm: lgLayout,
    xs: buildStackedLayout(lgLayout, BREAKPOINT_COLS.xs),
    xxs: buildStackedLayout(lgLayout, BREAKPOINT_COLS.xxs),
  };
};

const applyExpandToLayouts = (layouts) => {
  if (!layouts) return layouts;

  const result = { ...layouts };
  const expandableBreakpoints = ['lg', 'md', 'sm'];

  for (const bp of expandableBreakpoints) {
    const layout = result[bp];
    if (layout?.length && BREAKPOINT_COLS[bp]) {
      result[bp] = expandWidgetsToAvailableSpace(layout, BREAKPOINT_COLS[bp]);
    }
  }

  return result;
};

export {
  buildLayoutItem,
  mergeStoredWithConstraints,
  buildResponsiveLayouts,
  applyExpandToLayouts,
};
